import React from 'react';
import PropTypes from 'prop-types';

const CheckboxFormatter = props => (
  <input
    id="cell-checkbox"
    type="checkbox"
    value={props.value}
    checked={props.checked}
    onClick={() => { props.handleOnClick(props); }}
    disabled={props.disabled}
  />
);

CheckboxFormatter.defaultProps = {
  value: false,
};

CheckboxFormatter.propTypes = {
  value: PropTypes.bool,
  handleOnClick: PropTypes.func.isRequired,
};

export default CheckboxFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/CheckboxFormatter.jsx